exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appInformation_box[data-v-2bf880f2]{padding:40px}.appInformation_box .title[data-v-2bf880f2]{width:100%;padding-bottom:8px;border-bottom:1px solid #ccc}.appInformation_box .content_box[data-v-2bf880f2]{margin-top:20px;width:800px}", ""]);

// exports
